import { useEffect, useState } from 'react';

import { useCurrentLocale } from '@/shared/utils/client';

import { bindInpostPay } from '../api';
import {
  getBasketBindingApiKeyToLocalStorage,
  removeBasketBindingApiKeyToLocalStorage,
  saveBasketBindingApiKeyToLocalStorage,
} from './use-basket-binding-api-key.utils';

export function useBasketBindingApiKey(basketId: string | null | undefined) {
  const locale = useCurrentLocale();
  const [state, setState] = useState<string | undefined | null>(null);

  useEffect(() => {
    const basketBindingApiKey = getBasketBindingApiKeyToLocalStorage();

    if (!basketBindingApiKey) {
      setState(undefined);
    }

    if (!basketId) {
      return;
    }

    if (basketBindingApiKey) {
      bindInpostPay(basketId, locale).then((basketBindingApiKey) => {
        if (basketBindingApiKey === '') {
          setState(undefined);
          removeBasketBindingApiKeyToLocalStorage();
        } else {
          setState(basketBindingApiKey);
        }
      });
    }
  }, [basketId, locale]);

  function saveBasketBindingApiKey(
    basketId: string,
    basketBindingApiKey: string
  ) {
    setState(basketBindingApiKey);
    saveBasketBindingApiKeyToLocalStorage(basketBindingApiKey);
  }

  return { basketBindingApiKey: state, saveBasketBindingApiKey };
}
